<template>
    <div class="flex items-center" :class="{ 'space-x-1': likeCount }">
        <div class="has-tooltip">
            <button @click="react" :class="[isLiked ? 'text-red-500 hover:text-red-700' : 'text-gray-500 -mr-2']" class="group inline-flex items-center -m-px p-2 text-gray-500 hover:text-red-500 font-medium rounded-full focus:outline-none cursor-pointer space-x-2">
                <svg :class="[isLiked ? 'fill-red-500' : 'fill-white']" class="w-6 h-6 group-focus:text-red-500 focus:outline-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                </svg>
            </button>
            <!--            <tooltip>{{ isLiked ? 'Unlike' : 'Like' }}</tooltip>-->
        </div>

        <div v-if="likes" class="flex items-center sm:space-x-2">
            <div class="relative z-0 flex overflow-hidden -space-x-1">
                <avatar v-for="(like, i) in latestLikes" :key="i" :class="['z-' + (latestLikes.length - i) + '0']" :src="like.profilePhotoUrl" class="hidden w-6 max-w-none h-6 rounded-full ring-2 ring-white sm:inline-block" />
            </div>
            <span v-if="likeCountOverflow" class="hidden flex-shrink-0 text-gray-500 text-sm leading-5 sm:inline-block"> + {{ likeCountOverflow | toLocaleString }} </span>
            <span class="flex-shrink-0 text-gray-500 text-sm leading-5 sm:hidden">
                {{ likeCount | toLocaleString }}
            </span>
        </div>
    </div>
</template>

<script>
import Tooltip from "@/Components/Tooltip"

export default {
    name: "React",
    components: { Tooltip },

    mounted() {
        Echo.channel("likeables." + this.reactantId)
            .listen(".reactant.liked", (e) => this.liked(e.reacter))
            .listen(".reactant.unliked", (e) => this.unliked(e.reacter))
    },

    props: {
        reactant: {
            required: true,
            type: Object,
        },
    },

    computed: {
        likes() {
            if (!this.reactant) return null
            return this.reactant.likes
        },

        isLiked() {
            if (!this.reactant || !this.$page.props.user) return null
            return _.some(this.likes, ["id", this.$page.props.user.id])
        },

        latestLikes() {
            return _.take(this.likes, this.latestLikeCount)
        },

        likeCount() {
            if (!this.likes) return false
            return this.likes.length
        },

        likeCountOverflow() {
            if (this.likeCount > this.latestLikeCount) {
                return this.likeCount - this.latestLikeCount
            }
        },
    },

    data() {
        return {
            latestLikeCount: 4,
            reactantId: this.reactant.id,
            form: this.$inertia.form({
                _method: "POST",
            }),
        }
    },

    methods: {
        react() {
            if (!this.reactant) return null
            if (this.isLiked) {
                this.deleteReaction()
            } else {
                this.storeReaction()
            }
        },

        storeReaction() {
            this.liked(this.$page.props.user)
            this.form.post(this.reactant.likeUrl, {
                preserveScroll: true,
                preserveState: true,
            })
        },

        deleteReaction() {
            this.unliked(this.$page.props.user)
            this.form.delete(this.reactant.likeUrl, {
                preserveScroll: true,
                preserveState: true,
            })
        },

        liked(reacter) {
            this.reactant.likes.unshift(reacter)
        },

        unliked(reacter) {
            this.reactant.likes = this.reactant.likes.filter((user) => user.id !== reacter.id)
        },
    },
}
</script>
